import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { BenefactorModel } from '../master/models/benefactor';

export class TableDetailDataSource extends DataSource<any> {

	data: BenefactorModel[] = [];

	connect(): Observable<Element[]> {
		const rows = [];
		this.data.forEach(element => rows.push(element, { detailRow: true, element }));
		return of(rows);
	}

	disconnect() { }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/utils/table-detail-data-source.ts